<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Pagination from "@/components/standard/Induction/components/InductionPagination";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import inspeccionesSeguridadAPI from "../../../services/standards/inspeccionesSeguridad/inspeccionesSeguridadAPI";
import EvaluacionIdentificacionPagination from "../../../components/standard/evaluacionIdentificacion/EvaluacionIdentificacionPagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "4.2.4 Inspecciones de seguridad",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    Pagination,
    PageHeader,
    Table,
    CheckModal,
    EvaluacionIdentificacionPagination
  },
  data() {
    return {
      title: "4.2.4 Inspecciones de seguridad",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "4.2.4 Inspecciones de seguridad",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: "",
      tipos: [],

      file: null,
      usersList: [],

      estilo: {
        activity: null,
        scheduled_date: null,
        observations: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      form_submitting: false,

      inspeccion: {
        schedule_date: null,
        other: null,
        silist_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      company: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      item: null,
      itemStatus: "No cumplido",
      deleteCount: 0,
      itemData: null,
    };
  },
  validations: {
    inspeccion: {
      employee_id: {
        required,
      },
      schedule_date: {
        required,
      },
      silist_id: {
        required,
      },
    },
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(48)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      this.submitted = true
      this.loading1 = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        inspeccionesSeguridadAPI
          .save(this.inspeccion)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 48,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(64, 48, true);
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 48)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 48,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    getInspeccion() {
      inspeccionesSeguridadAPI.get(this.companyID)
        .then((response) => {
          this.list = response.data.data;
          if (Array.isArray(this.list)) {
            this.deleteCount = this.list.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    deleteSeguimiento(id) {
      inspeccionesSeguridadAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 48,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "Éxito!",
                text: "¡Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      inspeccionesSeguridadAPI
        .getList(this.companyID)
        .then((response) => {
          this.tipos = response.data;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATO_INSPECCION_SEGURIDAD.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.getData();
    this.getItems();
    this.getUsers();
    this.getItemData();
    this.getList();
    this.getInspeccion();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12 pl-3">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe realizar las visitas de inspección
                      sistemática a las instalaciones, maquinaria o equipos,
                      incluidos los relacionados con la prevención y atención de
                      emergencias; con la participación del COPASST.
                    </p>
                    <p class="text-justify">
                      En este ítem el responsable de la implementación, debe
                      elaborar la programación de las diferentes inspecciones a
                      realizar, definiendo la frecuencias de éstas y
                      posteriormente debe subir las evidencias que soportes las
                      inspecciones realizadas.
                    </p>
                    <p class="text-justify">
                      En caso de evidenciar alguna condición insegura que
                      requiera intervención, deberá elaborar el plan de acción
                      en el ítem 7.1.1
                    </p>
                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Descargar formato de inspección de seguridad
                  </button>
                </div>
              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-4 px-2" label="Seleccionar inspección a realizar" label-for="inpeccion">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="inspeccion.silist_id" :class="{
                        'is-invalid': $v.inspeccion.silist_id.$error && submitted,
                      }">
                      <b-form-select-option v-for="item in tipos" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.inspeccion.silist_id.$error">
                      <small v-if="!$v.inspeccion.silist_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Fecha Programada" label-for="trainingDate">
                    <b-form-input type="date" id="trainingDate" :class="{
                      'is-invalid': $v.inspeccion.schedule_date.$error && submitted,
                    }" v-model="inspeccion.schedule_date" :disabled="!allowAccess() || !getRole('Crear')">
                    </b-form-input>
                    <div v-if="submitted && $v.inspeccion.schedule_date.$error">
                      <small v-if="!$v.inspeccion.schedule_date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Responsable" label-for="employee">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="inspeccion.employee_id" :class="{
                        'is-invalid': $v.inspeccion.employee_id.$error && submitted,
                      }">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.inspeccion.employee_id.$error">
                      <small v-if="!$v.inspeccion.employee_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div v-if="inspeccion.silist_id === 7" class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Otro ¿Cuál?" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="inspeccion.other" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
              <hr class="px-2" />
              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead>
                          <tr>
                            <th class="text-center align-middle">Fecha</th>
                            <th class="text-center align-middle">Inspección a realizar</th>
                            <th class="text-center align-middle">Fecha programada</th>
                            <th class="text-center align-middle">Responsable</th>
                            <th class="text-center align-middle">Acciones</th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="dato in list" :key="dato.id">
                            <td class="text-center align-middle">
                              {{ dateConvert(dato.created_at) }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.name }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.schedule_date }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.full_name }}
                            </td>

                            <td class="text-center align-middle">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary" :disabled="!allowAccess()">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                                    :to="{ path: `/forms/estandares/inspecciones-seguridad-editar/${dato.id}` }">
                                    Editar
                                  </b-dropdown-item>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                                    :to="{ path: `/forms/estandares/evidencia-inspeccion/${dato.id}` }">
                                    Evidencia inspección
                                  </b-dropdown-item>
                                  <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                    v-on:click="deleteSeguimiento(dato.id)">Eliminar</b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </td>

                          </tr>

                        </tbody>

                      </table>
                      <EvaluacionIdentificacionPagination ref="paginator" :search="search"
                        @fetch="(items) => (lista = items)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
